export const getLevelContiguousNotBuiltLinearValidity = (
  contiguousNotBuiltLinear: number | undefined,
  maxContiguousNotBuiltLinear: number
): boolean =>
  contiguousNotBuiltLinear === undefined || contiguousNotBuiltLinear <= maxContiguousNotBuiltLinear;
